module.exports = "https://web-assets.ifttt.com/packs/media/partners/maker_platform-e806261e.svg";